import Optimizer from './Optimizer.svelte';
import NbaSchedule from './NbaSchedule.svelte';
import NflProj from './NflProj.svelte';
import NbaProj from './NbaProj.svelte';
import DailySwiper from './DailySwiper.svelte';
import MlbProj from './MlbProj.svelte';
import NhlProj from './NhlProj.svelte';
window.Optimizer = function (options) {
    return new Optimizer(options);
};
window.NbaSchedule = function (options) {
    return new NbaSchedule(options);
};
window.NflProj = function (options) {
    return new NflProj(options);
};
window.NbaProj = function (options) {
    return new NbaProj(options);
};
window.DailySwiper = function (options) {
    return new DailySwiper(options);
};
window.MlbProj = function (options) {
    return new MlbProj(options);
};
window.NhlProj = function (options) {
    return new NhlProj(options);
};
